// extracted by mini-css-extract-plugin
export default {"wrapper":"introduction_wrapper__2qamj","button":"introduction_button__1SlTN"};